import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
// import elementEsLocale from 'element-ui/lib/locale/lang/es'// element-ui lang
// import elementJaLocale from 'element-ui/lib/locale/lang/ja'// element-ui lang
// import idLocale from './id'
// import esLocale from './es'
// import jaLocale from './ja'

/** 开发模式 */
import enLocale from './en'
import zhLocale from './zh'
/** end 开发模式 */

/** 正式环境 */
// var enLocale, zhLocale
// function fn2() {
//   // 发送同步请求
//   // 1.创建ajax引擎对象----所有操作都是由ajax引擎完成
//   var xmlHttp = new XMLHttpRequest()

//   // 2.为引擎对象绑定监听事件
//   xmlHttp.onreadystatechange = () => {
//     // 当状态变化时处理的事情
//     if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
//       // 5.接收响应信息
//       var langData = JSON.parse(xmlHttp.responseText)
//       enLocale = JSON.parse(langData.data.en)
//       zhLocale = JSON.parse(langData.data.zh)
//     }
//   }
//   // 3.绑定服务器地址
//   // 第一个参数：请求方式GET/POST
//   // 第二个参数：后台服务器地址
//   // 第三个参数：是否是异步,true--异步,false--同步
//   xmlHttp.open('GET', `${process.env.VUE_APP_BASE_API}/alp/auth/getJons`, false)
//   // xmlHttp.open('GET', `${process.env.VUE_APP_BASE_API}/alp/auth/getJs`, false)
//   // 4.发送请求
//   xmlHttp.send()
// }
// fn2()

/** end 正式环境 */
Vue.use(VueI18n)

export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(getMessages())
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}
export function getMessages() {
  var messages = {
    en: {
      ...enLocale,
      ...elementEnLocale
    },
    zh: {
      ...zhLocale,
      ...elementZhLocale
    }
  }
  return messages
}

const i18n = new VueI18n({
  messages: getMessages(),
  // set locale
  // options: en | zh | es
  locale: getLanguage()
  // set locale messages
})

export default i18n
